import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CSS = `
  @keyframes bg-move  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
  @keyframes orb-a    { 0%,100%{transform:translate(0,0) scale(1)} 40%{transform:translate(40px,-30px) scale(1.08)} 70%{transform:translate(-20px,15px) scale(.94)} }
  @keyframes orb-b    { 0%,100%{transform:translate(0,0)} 33%{transform:translate(-30px,20px)} 66%{transform:translate(20px,-20px)} }
  @keyframes glow     { 0%,100%{box-shadow:0 0 24px rgba(200,0,90,.5),0 0 48px rgba(200,0,90,.2)} 50%{box-shadow:0 0 48px rgba(200,0,90,.8),0 0 96px rgba(200,0,90,.35)} }
  @keyframes sh-text  { 0%{background-position:-200% center} 100%{background-position:200% center} }
  @keyframes slide-d  { from{opacity:0;transform:translateY(-20px)} to{opacity:1;transform:none} }
  @keyframes slide-u  { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:none} }
  @keyframes spin     { to{transform:rotate(360deg)} }
  .rg-orb-a { animation: orb-a 10s ease-in-out infinite; }
  .rg-orb-b { animation: orb-b 13s ease-in-out infinite; }
  .rg-glow  { animation: glow 2.5s ease-in-out infinite; }
  .rg-logo  { background:linear-gradient(135deg,#C8005A 0%,#9B6FD4 50%,#00CFDB 100%); background-size:200% auto; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; animation:sh-text 3s linear infinite; }
  .rg-sd    { animation: slide-d .6s cubic-bezier(.16,1,.3,1) both; }
  .rg-su    { animation: slide-u .6s cubic-bezier(.16,1,.3,1) .08s both; }
  .rg-inp   { width:100%; padding:.75rem 1rem; border-radius:.75rem; background:rgba(255,255,255,.09); border:1.5px solid rgba(255,255,255,.12); color:#fff; font-size:.875rem; outline:none; box-sizing:border-box; transition:all .2s; }
  .rg-inp::placeholder { color:rgba(255,255,255,.3); }
  .rg-inp:focus { border-color:rgba(200,0,90,.7); background:rgba(255,255,255,.14); box-shadow:0 0 0 3px rgba(200,0,90,.18); }
  .rg-btn   { width:100%; padding:.875rem; border:none; border-radius:.75rem; background:#C8005A; color:#fff; font-size:.9rem; font-weight:700; cursor:pointer; box-shadow:0 4px 24px rgba(200,0,90,.45); transition:all .2s; }
  .rg-btn:hover:not(:disabled) { background:#E8006F; box-shadow:0 6px 32px rgba(200,0,90,.65); transform:translateY(-1px); }
  .rg-btn:disabled { opacity:.55; cursor:not-allowed; }
`;

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username:'', password:'', confirm:'', first_name:'', last_name:'' });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');
  const [ready,   setReady]   = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  useEffect(() => { setTimeout(()=>setReady(true), 60); }, []);

  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (form.password !== form.confirm) return setError('Пароли не совпадают');
    if (form.password.length < 6) return setError('Пароль минимум 6 символов');
    setLoading(true);
    try { await register({ username:form.username, password:form.password, first_name:form.first_name||undefined, last_name:form.last_name||undefined }); navigate('/profile'); }
    catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', position:'relative', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
      <style>{CSS}</style>

      {/* Animated BG */}
      <div style={{ position:'absolute', inset:0, background:'linear-gradient(-45deg,#0E0B18,#1A0032,#210A2E,#0A0A1C,#140F28)', backgroundSize:'400% 400%', animation:'bg-move 12s ease infinite' }}/>
      <div style={{ position:'absolute', inset:0, backgroundImage:'linear-gradient(rgba(200,0,90,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(200,0,90,.06) 1px,transparent 1px)', backgroundSize:'56px 56px' }}/>

      {/* Orbs */}
      <div className="rg-orb-a" style={{ position:'absolute', top:'5%', right:'8%', width:480, height:480, borderRadius:'50%', background:'radial-gradient(circle,rgba(155,111,212,.35) 0%,rgba(155,111,212,.1) 40%,transparent 68%)', filter:'blur(35px)', pointerEvents:'none' }}/>
      <div className="rg-orb-b" style={{ position:'absolute', bottom:'5%', left:'5%', width:400, height:400, borderRadius:'50%', background:'radial-gradient(circle,rgba(200,0,90,.3) 0%,rgba(200,0,90,.08) 40%,transparent 68%)', filter:'blur(40px)', pointerEvents:'none' }}/>

      {/* Content */}
      <div style={{ position:'relative', zIndex:10, width:'100%', maxWidth:400, opacity:ready?1:0, transition:'opacity .5s' }}>

        {/* Logo */}
        <div className="rg-sd" style={{ textAlign:'center', marginBottom:'1.5rem' }}>
          <div className="rg-glow" style={{ display:'inline-flex', width:72, height:72, borderRadius:20, background:'linear-gradient(135deg,#C8005A,#8B003D)', alignItems:'center', justifyContent:'center', marginBottom:14 }}>
            <span style={{ color:'#fff', fontFamily:'system-ui', fontWeight:900, fontSize:26, letterSpacing:-1 }}>MS</span>
          </div>
          <h1 className="rg-logo" style={{ fontFamily:'system-ui', fontSize:'2.4rem', fontWeight:900, letterSpacing:-2, lineHeight:1, margin:0 }}>MolShape</h1>
          <p style={{ color:'rgba(255,255,255,.4)', fontSize:'.85rem', marginTop:6 }}>Твой прогресс. Твоя форма.</p>
        </div>

        {/* Card */}
        <div className="rg-su" style={{ background:'rgba(255,255,255,.07)', backdropFilter:'blur(28px)', WebkitBackdropFilter:'blur(28px)', border:'1.5px solid rgba(255,255,255,.13)', borderRadius:24, padding:'1.75rem', boxShadow:'0 30px 60px rgba(0,0,0,.55)' }}>
          <h2 style={{ color:'#fff', fontFamily:'system-ui', fontWeight:700, fontSize:'1.15rem', margin:'0 0 1.25rem' }}>Регистрация</h2>

          {error && <div style={{ background:'rgba(239,68,68,.15)', border:'1px solid rgba(239,68,68,.3)', borderRadius:12, padding:'10px 14px', marginBottom:14, color:'#fca5a5', fontSize:'.875rem' }}>⚠️ {error}</div>}

          <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:12 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
              <div>
                <label style={{ display:'block', color:'rgba(255,255,255,.45)', fontSize:'.72rem', fontWeight:500, marginBottom:5 }}>Имя</label>
                <input className="rg-inp" placeholder="Алёна" value={form.first_name} onChange={e=>set('first_name',e.target.value)} />
              </div>
              <div>
                <label style={{ display:'block', color:'rgba(255,255,255,.45)', fontSize:'.72rem', fontWeight:500, marginBottom:5 }}>Фамилия</label>
                <input className="rg-inp" placeholder="Иванова" value={form.last_name} onChange={e=>set('last_name',e.target.value)} />
              </div>
            </div>
            <div>
              <label style={{ display:'block', color:'rgba(255,255,255,.45)', fontSize:'.72rem', fontWeight:500, marginBottom:5 }}>Логин *</label>
              <input className="rg-inp" placeholder="alyona_fit" autoCapitalize="off" value={form.username} onChange={e=>set('username',e.target.value)} required />
              <p style={{ color:'rgba(255,255,255,.25)', fontSize:'.7rem', margin:'4px 0 0' }}>Латиница, цифры, _ (3-30 символов)</p>
            </div>
            <div>
              <label style={{ display:'block', color:'rgba(255,255,255,.45)', fontSize:'.72rem', fontWeight:500, marginBottom:5 }}>Пароль *</label>
              <input className="rg-inp" type="password" placeholder="Минимум 6 символов" value={form.password} onChange={e=>set('password',e.target.value)} required />
            </div>
            <div>
              <label style={{ display:'block', color:'rgba(255,255,255,.45)', fontSize:'.72rem', fontWeight:500, marginBottom:5 }}>Повтори пароль *</label>
              <input className="rg-inp" type="password" placeholder="••••••••" value={form.confirm} onChange={e=>set('confirm',e.target.value)} required />
            </div>

            <button type="submit" className="rg-btn" disabled={loading} style={{ marginTop:4 }}>
              {loading
                ? <span style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                    <span style={{ width:16, height:16, border:'2.5px solid rgba(255,255,255,.3)', borderTopColor:'#fff', borderRadius:'50%', animation:'spin .7s linear infinite', display:'inline-block' }}/>
                    Создаю аккаунт...
                  </span>
                : 'Создать аккаунт'}
            </button>
          </form>

          <p style={{ textAlign:'center', fontSize:'.78rem', color:'rgba(255,255,255,.28)', marginTop:16, marginBottom:0 }}>
            Уже есть аккаунт?{' '}
            <Link to="/login" style={{ color:'#E8006F', textDecoration:'none', fontWeight:600 }}>Войти</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
